import { createRouter, createWebHistory } from 'vue-router'
import MarkmapPage from '@/page/MarkmapPage.vue'
import IndexPage from '@/page/IndexPage.vue'
import FlutterChannelPage from '@/page/test/FlutterChannelPage.vue'

// 1. 创建路由实例
const router = createRouter({
  // Vue CLI 项目使用 process.env.BASE_URL
  history: createWebHistory(process.env.BASE_URL || '/'), 
  routes: [
    {
      path: '/',
      name: 'IndexPage',
      component: IndexPage,
      meta: { title: '乃师 - 乃师学英语，一个APP就够了' }
    },
    {
      path: '/markmap',
      name: 'MarkmapPage',
      component: MarkmapPage,
      meta: { title: 'markmap' }
    },
    {
      path: '/flutterChannel',
      name: 'FlutterChannelPage',
      component: FlutterChannelPage,
      meta: { title: 'flutterChannel' }
    }
  ]
})

// 2. 导航守卫保持不变
router.beforeEach((to) => {
  document.title = to.meta.title || 'langwise'
})

export default router